import { graphql } from '~/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphqlRequest } from '~/lib/graphql-client';
import { ClientError } from 'graphql-request';

type DeleteOrderDocumentInput = {
  orderId: string;
  documentId: string;
};

type DownloadOrderDocumentInput = {
  documentId: string;
};

export function useDeleteOrderDocument() {
  const queryClient = useQueryClient();
  const deleteMutation = graphql(`
    mutation DeleteOrderDocument($id: ID!) {
      deleteOrderDocument(id: $id)
    }
  `);

  return useMutation<unknown, ClientError, DeleteOrderDocumentInput>({
    mutationFn: ({ documentId }: DeleteOrderDocumentInput) =>
      graphqlRequest(deleteMutation, { id: documentId }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['orders', variables.orderId],
      });
    },
  });
}

export function useDownloadOrderDocument() {
  const presignedUrlQuery = graphql(`
    query OrderDocumentPresignedUrl($id: ID!) {
      orderDocumentPresignedUrl(id: $id)
    }
  `);

  return useMutation<
    { orderDocumentPresignedUrl: string },
    ClientError,
    DownloadOrderDocumentInput
  >({
    mutationFn: ({ documentId }: DownloadOrderDocumentInput) =>
      graphqlRequest(presignedUrlQuery, { id: documentId }),
    onSuccess: (data) => {
      const url = data.orderDocumentPresignedUrl;
      if (/^https?:\/\//i.test(url)) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
  });
}
